import { TypographyHeadingTable, TypographyBodyTable, TypographyMetricTable, TypographyCodeTable } from '@af/design-system-docs-ui';
import { FeatureBlock } from '@af/design-system-docs-ui/feature-block';
import { FeatureBlockGrid } from '@af/design-system-docs-ui/feature-block-grid';
import { principles } from "../../../../src/pages/foundations/typography/_content/_principles";
import * as React from 'react';
export default {
  TypographyHeadingTable,
  TypographyBodyTable,
  TypographyMetricTable,
  TypographyCodeTable,
  FeatureBlock,
  FeatureBlockGrid,
  principles,
  React
};